/**
 * Fatal Attraction configuration object for use with faHelper.
 */
const FATAL_ATTRACTION_CONFIG = {
  faSpecs: {
    /* Album actions */
    editAlbum: {
      container: 'album_player',
      component: 'album',
      keyword: 'edit',
    },

    albumCustomization: {
      container: 'edit_album_modal',
      component: 'customization',
    },

    albumCustomizeUpgrade: {
      container: 'edit_album_modal',
      component: 'upgrade_link',
    },

    toggleAlbumShare: {
      container: 'album_player',
      component: 'album',
      keyword: 'share',
    },

    downloadStockPreview: {
      container: 'stock_creator_albums',
      component: 'download',
    },

    addStockToCart: {
      container: 'stock_creator_albums',
      component: 'add_to_cart',
    },

    albumTitle: {
      container: 'stock_creator_albums',
      component: 'view_clip',
    },

    addStockToAccount: {
      container: 'stock_creator_albums',
      component: 'add_to_account_confirm',
    },
  },
};

export default FATAL_ATTRACTION_CONFIG;
